module.exports = "/_next/static/images/CriticalLifeCOVER_Mini-Web-Banner-2c2e80bd05103edf432a95c5955b1f97.jpg";